module.exports = __webpack_public_path__ + "static/media/creaky-joints-logo.c6bbd8b4.webp";